import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        id: undefined,
        email: undefined,
        loggedIn: undefined,
        role: undefined,
        profile: undefined,
        active: undefined,
        error: undefined,
        emailVerified: undefined,
        subrole: undefined,
    },
    reducers: {
        login: (state, action) => {
            state.id = action.payload.id;
            state.email = action.payload.email;
            state.loggedIn = true;
            state.emailVerified = true;
        },
        logout: (state) => {
            state.loggedIn = false;
        },
        setInfo: (state, action) => {
            state.role = action.payload.role;
            state.profile = action.payload.profile;
            state.active = action.payload.active;
            state.subrole = action.payload.subrole;
        },
        setError: (state, action) => {
            state.error = action.payload.error;
        }
    }
})

export const { login, logout, setInfo, setError } = userSlice.actions;
export default userSlice.reducer;